import './BusquedaTurnosPage.css'
import TablaBusquedaDeTurnos from '../../components/tablaBusquedaDeTurnos/TablaBusquedaDeTurnos.jsx'

const BusquedaDeTurnosPage = () =>{
    return (
        <>
        <div className = "BusquedaDeTurnosPage-body">
            <TablaBusquedaDeTurnos />
        </div>
        </>
    );
};

export default BusquedaDeTurnosPage;